import React from "react"
import Styles from "./ForHealthCoachTrainingStyles.module.styl"
import Image from "gatsby-image"
import translate from "../../../../../translation/translator"
import keys from "../../../../../translation/keys"

const ForHealthCoachTraining = ({
  toggleActiveIncomeProgram,
  activeIncomeProgram,
  beOrganizedProgram,
  toggleActiveOrganizedProgram,
  toggleActiveOnlineConsultationProgram,
  onlineConsultationProgram,
  healthCoachProgramImages,
  locale,
}) => {
  const image1 = healthCoachProgramImages[1].node.childImageSharp.fluid
  const image2 = healthCoachProgramImages[2].node.childImageSharp.fluid
  const image3 = healthCoachProgramImages[0].node.childImageSharp.fluid
  return (
    <div className={Styles.wrapper}>
      <div className={Styles.program_holder}>
        <h2>
          {translate(keys.HLTH_COACH_TRAINING_ONLINE_COUNSULTATION, locale)}
        </h2>
        <div
          role="button"
          tabIndex={0}
          onKeyDown={toggleActiveIncomeProgram}
          onClick={toggleActiveIncomeProgram}
          className={
            activeIncomeProgram === true
              ? Styles.active_program
              : Styles.program
          }
        >
          <h3>{translate(keys.HLTH_COACH_TRAINING_INCOME, locale)}</h3>
          <p>{translate(keys.HLTH_COACH_TRAINING_INCOME_TEXT, locale)}</p>
        </div>
        <div
          role="button"
          tabIndex={0}
          onKeyDown={toggleActiveOrganizedProgram}
          onClick={toggleActiveOrganizedProgram}
          className={
            beOrganizedProgram === true ? Styles.active_program : Styles.program
          }
        >
          <h3>{translate(keys.HLTH_COACH_TRAINING_SCHEDULE, locale)}</h3>
          <p>{translate(keys.HLTH_COACH_TRAINING_SCHEDULE_TEXT, locale)}</p>
        </div>
        <div
          role="button"
          tabIndex={0}
          onKeyDown={toggleActiveOnlineConsultationProgram}
          onClick={toggleActiveOnlineConsultationProgram}
          className={
            onlineConsultationProgram === true
              ? Styles.active_program
              : Styles.program
          }
        >
          <h3>{translate(keys.HLTH_COACH_TRAINING_CONSULTATION, locale)}</h3>
          <p>{translate(keys.HLTH_COACH_TRAINING_CONSULTATION_TEXT, locale)}</p>
        </div>
      </div>
      <div className={Styles.image_holder}>
        {activeIncomeProgram === true && (
          <Image alt="active-income-program" fluid={image1} />
        )}
        {beOrganizedProgram === true && (
          <Image alt="be-organized-program" fluid={image2} />
        )}
        {onlineConsultationProgram === true && (
          <Image alt="online-consultation-program" fluid={image3} />
        )}
      </div>
    </div>
  )
}

export default ForHealthCoachTraining
